<template>
  <ResponsiveConfirmDialog
    :show="show"
    :title="__('Delete File')"
    role="alertdialog"
    size="md"
    @close="handleClose"
    @close-via-escape="handleClose"
  >
    <div
      class="panel-confirm-dialog max-md:!bg-transparent overflow-hidden rounded-3xl border border-zinc-200/70 bg-white shadow-2xl dark:border-zinc-800 dark:bg-zinc-900 dark:max-md:!bg-transparent max-md:rounded-none max-md:border-0 max-md:shadow-none"
    >
      <ModalHeader class="max-md:hidden" v-text="__('Delete File')" />
      <ModalContent>
        <p class="leading-relaxed">
          {{ __('Are you sure you want to delete this file?') }}
        </p>
      </ModalContent>
      <ModalFooter class="max-md:hidden">
        <div class="panel-confirm-footer-actions ml-auto flex w-full items-center">
          <LinkButton
            dusk="cancel-upload-delete-button"
            type="button"
            class="mr-3"
            @click.prevent="handleClose"
          >
            {{ __('Cancel') }}
          </LinkButton>

          <Button
            @click.prevent="handleConfirm"
            ref="confirmButton"
            dusk="confirm-upload-delete-button"
            :loading="working"
            state="danger"
            :label="__('Delete')"
          />
        </div>
      </ModalFooter>
    </div>

    <template #footer>
      <div class="panel-confirm-footer-actions panel-confirm-footer-actions--sheet w-full">
        <LinkButton
          type="button"
          class="flex-1 justify-center"
          dusk="cancel-upload-delete-button"
          @click.prevent="handleClose"
        >
          {{ __('Cancel') }}
        </LinkButton>

        <Button
          class="flex-1"
          @click.prevent="handleConfirm"
          dusk="confirm-upload-delete-button"
          :loading="working"
          state="danger"
          :label="__('Delete')"
        />
      </div>
    </template>
  </ResponsiveConfirmDialog>
</template>

<script>
import { Button } from 'laravel-nova-ui'

export default {
  components: {
    Button,
  },

  emits: ['confirm', 'close'],

  props: {
    show: { type: Boolean, default: false },
  },

  mounted() {
    // this.$refs.confirmButton.focus()
  },

  data: () => ({ working: false }),

  watch: {
    show(showing) {
      if (showing === false) {
        this.working = false
      }
    },
  },

  methods: {
    handleClose() {
      this.working = false
      this.$emit('close')
    },

    handleConfirm() {
      this.working = true
      this.$emit('confirm')
    },
  },
}
</script>
